import { User } from "../../models/User/user.model";
import {  AUTHENTICATED, SET_CUSTOMER, SET_USER, UNAUTHENTICATED } from "../definitions/authConstants";
import { ActionProps } from "../../shared/types/action.type";
import { Customer } from "../../models/Customer/customer.model";

export const setAuthenticated = (user: User): ActionProps => ({
    type: AUTHENTICATED,
    payload: {
        authenticated: true,
        user
    }
})

export const setUnAuthenticated = (): ActionProps => {
    return {
        type: UNAUTHENTICATED,
        payload: {
            authenticated: false,
            user: null
        }
    }
}

export const setUser = (user: User): ActionProps => ({
    type: SET_USER,
    payload: {
        user
    }
})

export const setCustomer = (customer: Customer): ActionProps => ({
    type: SET_CUSTOMER,
    payload: {
        customer
    }
})